class Mensajes extends React.Component {
  constructor(props) {
    super(props);
    this.handleHide = this.handleHide.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.state = {
      showModal:
        this.props.showModal === undefined ? true : this.props.showModal
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showModal) {
      this.setState({ showModal: true });
    }
    if (!nextProps.showModal && this.state.showModal && this.props.showModal) {
      this.handleHide();
    }
  }

  handleHide() {
    if (this.props.handleHide) {
      this.props.handleHide();
    }
    this.setState({ showModal: false });
  }

  handleShow() {
    this.setState({ showModal: true });
  }

  render() {
    return (
      <div id="modal-wrap">
        <Modal
          show={this.state.showModal}
          container={this.props.container}
          onHide={this.handleHide}
          bsSize="large"
          backdrop="static"
          aria-labelledby="contained-modal-title-sm"
        >
          <Modal.Header>
            <button
              id="close-modal"
              type="button"
              className="close-button"
              onClick={this.handleHide}
            >
              <i className="fa fa-times" />
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="body-container">
              <div className="col-sm-3 col-xs-12 icon-container">
                <i className="fa fa-times-circle-o red" aria-hidden="true"></i>
              </div>
              <div className="col-sm-9 col-xs-12 messages">
                {this.props.msg || "Discúlpenos, por favor intente más tarde"}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const Modal = ReactBootstrap.Modal;

export default Mensajes;


// WEBPACK FOOTER //
// ./base/components/mensajes.js